import React from 'react'
import { Tooltip as MaterialToolTip } from '@mui/material'

export const ToolTip = (props: any) => (<MaterialToolTip
  placement='bottom'
  leaveDelay={1500}
  {...props}
/>)

export default ToolTip
